import Ajv, { KeywordDefinition } from 'ajv'
import ajvErrors from 'ajv-errors'
import addFormats from 'ajv-formats'
import { asyncTest, dateAfterField, dateBeforeField } from './customAjvKeywords'

export const ajv = new Ajv({
  strict: false,
  allErrors: true,
  multipleOfPrecision: 8,
  removeAdditional: true,
})
ajvErrors(ajv)
addFormats(ajv)
ajv.addKeyword(asyncTest)
ajv.addKeyword(dateBeforeField)
ajv.addKeyword(dateAfterField)

const uiParamsKeyword: KeywordDefinition = {
  keyword: 'ui-params',
  type: ['object'],
  schemaType: 'object',
  valid: true, // it does not invalidate data
  metaSchema: {
    type: 'object',
    additionalProperties: true, // arbitrary params allowed
  },
}

ajv.addKeyword(uiParamsKeyword)
